import React from 'react'
import { cn, selectVariants } from './utils'

export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  variant?: 'default' | 'error'
  size?: 'default' | 'sm' | 'lg'
  error?: boolean
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, variant = 'default', size = 'default', error = false, children, ...props }, ref) => {
    const variantToUse = error ? 'error' : variant
    
    return (
      <select
        className={cn(
          selectVariants.variant[variantToUse],
          selectVariants.size[size],
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </select>
    )
  }
)

Select.displayName = 'Select'

export { Select } 